import ProductInventory from "../model/ProductInventory";
import storeInUse from "src/storeWire";
import { fetchInventoryFromServer } from "../store/slice/model/ProductInventory";
import { chunk, isArray, isObject } from "underscore";
import Product from "@system/config/product";
import axios_c_for_price_and_inventory from "src/service/axios_c_for_price_and_inventory";
import Helper from "src/support/Helper";
import { __set, __remove } from "src/store/axios_indicator";
import Api from "./APIHandler";
const API = new Api({});
class ProductInventoryAPICall {

    async get_data_from_master_store_by_params(params) {
        let data = {};
        let master_data = {};
        let ERPPartNumber_map_with_ItemNumber = {};
        if (storeInUse !== undefined && storeInUse) {
            let storeIn = await storeInUse.getState();
            master_data = storeIn.entities.model_ProductInventory.master_data;
            ERPPartNumber_map_with_ItemNumber = storeIn.entities.model_ProductListing.ERPPartNumber_map_with_ItemNumber;
        }
        params.map((v) => {
            if (master_data[v.ERPPartNumber] !== undefined) {
                data[v.ERPPartNumber] = master_data[v.ERPPartNumber];
                if (ERPPartNumber_map_with_ItemNumber && ERPPartNumber_map_with_ItemNumber[v.ERPPartNumber] !== undefined) {
                    data[ERPPartNumber_map_with_ItemNumber[v.ERPPartNumber]] = master_data[v.ERPPartNumber]
                }
            }
        });
        return data;
    }

    async params_maker_from_master_data(params) {
        let server_left_params = [];
        let master_data = {};
        if (storeInUse !== undefined && storeInUse) {
            let storeIn = await storeInUse.getState();
            master_data = storeIn.entities.model_ProductInventory.master_data;
        }
        params.map((v) => {
            if (master_data[v.ERPPartNumber] === undefined) {
                server_left_params.push(v);
            }
        });
        return {
            server_left_params
        };
    }

    async getInventory(params = false, force_api_call = false) {
        let res = []
        if (!params) {
            params = [
                {
                    "matnr": "ERPPartNumber",
                    "mfr": "ERPManufacturerCode",
                    "sboat": "sboat"
                }
            ];
        }
        if (params.length) {
            params = params.map((params_single) => {
                return new ProductInventory().setParamsForServerCall(params_single)
            });
            let params_maker;
            if (force_api_call === false) {
                params_maker = await this.params_maker_from_master_data(params);
            } else {
                params_maker = [];
                params_maker.server_left_params = [];
                params_maker.server_left_params = params;
            }
            // Restrict if PartNumber is null
            if (isObject(params_maker.server_left_params)) {
                if (params_maker.server_left_params.ERPPartNumber === null) return false;
            }
            if (isArray(params_maker.server_left_params) && params_maker.server_left_params.length > 0) {
                if (params_maker.server_left_params.filter(x => x.ERPPartNumber === null).length > 0) {
                    params_maker.server_left_params = params_maker.server_left_params.filter(x => x.ERPPartNumber !== null)
                }
            }

            if ((params_maker.server_left_params.length > 0 || force_api_call === true)) {
                let ar = chunk(params_maker.server_left_params, params_maker.server_left_params.length);
                await Promise.all(ar.map(async (arv) => {
                    res = await this.getProductInventory(arv, force_api_call)
                    // await storeInUse.dispatch(fetchInventoryFromServer(arv, force_api_call));
                }))
            }
        }
        await storeInUse.dispatch(fetchInventoryFromServer(res))
        return res
        // return await this.get_data_from_master_store_by_params(params);
    };

    async getProductInventory(server_left_params = false, force_api_call = false) {
        if (!server_left_params && !force_api_call) {
            __remove('PRODUCT_INVENTORY_API_CALL');
            return {
                data: {}
            };
        }
        if (!isArray(server_left_params) && !force_api_call) {
            __remove('PRODUCT_INVENTORY_API_CALL');
            return {
                data: {}
            };
        }
        if (isArray(server_left_params) && server_left_params.length < 1 && !force_api_call) {
            __remove('PRODUCT_INVENTORY_API_CALL');
            return {
                data: {}
            };
        };

        if (isArray(server_left_params) && server_left_params.length < 1) {
            __remove('PRODUCT_INVENTORY_API_CALL');
            return {
                data: {}
            };
        }
        const config = {
            method: 'post',
            url: Product.PRODUCT_INVENTORY,
            headers: Helper.getCommonHeader('POST', 'application/json'),
            data: {
                "iT_INVENTORY": server_left_params
            }
        };
        let res_axios = {};
        __set('PRODUCT_INVENTORY_API_CALL');
        await axios_c_for_price_and_inventory(config)
            .then(async function (response) {
                res_axios = response.data.data.eT_INVENTORY;
            }).catch(function () {
                //System.toast('Inventory Failed', 'error')
                __remove('PRODUCT_INVENTORY_API_CALL');
            });
        __remove('PRODUCT_INVENTORY_API_CALL');

        return {
            data: res_axios
        };
    };
    async getFarnellInventoryDetail(ERPPartNumber) {
        let res = {};
        await API.get(Product.PRODUCT_INVENTORY_FARNELL + '?erpPartNumber=' + ERPPartNumber).then((resHer) => {
            if (resHer.data) {
                res = resHer.data.Data?.FarnellAPIResponseModel?.Products
            }
        });
        return res
    }

    async setStockAlertNotification(params) {
        let data = null;
        let param = {}
        param.data = params
        await API.post(Product.STOCK_ALERT_NOTIFY, param).then((resHer) => {
            data = resHer.data;
        }).catch((err) => data = err);
        return data;
    }
}

export default ProductInventoryAPICall;